import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import './favorite.less';

export const Favorite = ({
  checked,
  onCheck,
  size,
  className: extraClassName,
}) => {
  const className = useClassName('Favorite');

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onCheck) onCheck(!checked);
  };

  const buttonClasses = [
    className('button', size),
    checked ? className('button', 'checked') : '',
    extraClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      onClick={handleClick}
      className={buttonClasses}
      aria-pressed={checked}
      aria-label={checked ? 'Remove from favorites' : 'Add to favorites'}>
      <svg
        className={className('icon')}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.3332 7.38518C18.3332 8.67395 17.8384 9.91177 16.9547 10.8274C14.9206 12.9359 12.9477 15.1344 10.8376 17.1664C10.3539 17.6254 9.58663 17.6086 9.12383 17.1289L3.04463 10.8274C1.20713 8.92267 1.20713 5.84769 3.04463 3.94298C4.9002 2.01954 7.92312 2.01954 9.77869 3.94298L9.99964 4.17201L10.2205 3.9431C11.1102 3.02042 12.3219 2.5 13.5876 2.5C14.8533 2.5 16.065 3.02037 16.9547 3.94298C17.8384 4.8587 18.3332 6.09647 18.3332 7.38518Z"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

Favorite.propTypes = {
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};

Favorite.defaultProps = {
  checked: false,
  size: 'medium',
};
